import { IonIcon, IonText } from '@ionic/react';

import styles from '@components/menus/MenuItemText.module.css';
import { IconList, IconName } from '@utils/iconUtils';

type Props = {
  icon: IconName;
  text: string;
};

const MenuText = ({ icon, text }: Props) => (
  <IonText className={styles.text}>
    <IonIcon aria-label={text} className={styles.icon} src={IconList[icon]} />
    {text}
  </IonText>
);

export default MenuText;
